
/* eslint-disable @typescript-eslint/no-useless-constructor */

import { eLynxObjectTypeEnum } from "../../common/enums/eLynxObjectType";
import Enumerable from "linq";
import { TimeframeType } from "../../common/enums/DRCXEnums";
import { NumericalFunctionEnum } from "../../common/enums/NumericalFunctionEnum";
import { IEquatable } from "../../common/models/IEquatable";
import { IGraphSeriesOptions } from "./Models";

export enum ChartDashStylesEnum {
    Solid,
    ShortDash,
    ShortDot,
    ShortDashDot,
    ShortDashDotDot,
    Dot,
    Dash,
    LongDash,
    DashDot,
    LongDashDot,
    LongDashDotDot
}

export enum ChartSymbolsEnum {
    None = -1,
    Circle,
    Diamond,
    Square,
    Triangle,
    Triangle_down
}

export enum ChartTypesEnum {
    Line,
    Spline,
    Area,
    Areaspline,
    Column,
    Bar,
    Pie,
    Scatter,
    Arearange,
    Areasplinerange,
    Columnrange,
    Gauge,
    Solidgauge,
    Boxplot,
    Waterfall,
    Funnel,
    Bubble,
    Heatmap,
    Step // Added to the end of the Highcharts definitions.
}



export interface IUIChartPropertiesClientChart {
    legendBoxVisible?: boolean;
}

export class UIChartPropertiesClientChart {
    legendBoxVisible: boolean = true;

    constructor(object?: IUIChartPropertiesClientChart) {
        //User Story 53044: Research - 2025 Q2 - Review GAS report
        if (object !== undefined && object !== null) {
            this.legendBoxVisible = object.legendBoxVisible !== undefined ? object.legendBoxVisible : false;
        }
        else {
            this.legendBoxVisible = true;
        }
    }
}

export interface IUIChartPropertiesClientSeries extends IEquatable<string> {
    color: string | undefined;
    gallery:ChartTypesEnum | undefined;
    id: string | undefined;
    index?: number;
    seriesIndex: number | undefined;
    lineStyle?:ChartDashStylesEnum;
    lineWidth?: number;
    markerShape?:ChartSymbolsEnum;
    name: string | undefined;

    // #region Version 1.2
    configDisplayName: string  | undefined;
    //deviceID: number;
    objectID: number | undefined;
    objectType:eLynxObjectTypeEnum | undefined;

    displayTatID: number | undefined;
    displayTatTypeID: number | undefined;
    groupingFunction:NumericalFunctionEnum | undefined;
    groupingTimeframe:TimeframeType | undefined;
    order: number | undefined;
    sectionID: string | undefined;
    tatTypeID?: number;
    trendTypeID: number | undefined;
    // #endregion

    tag: string | undefined;
    tatID: number | undefined;
    uniqueID: string | undefined; // ???

    /// <summary>
    /// When using dual or multiple y axes, this number defines which yAxis the particular
    /// series is connected to. It refers to the index of the axis in the yAxis array, with 
    /// 0 being the first. Defaults to 0
    /// </summary>
    yAxis: number | undefined;
    // We should not need this on the client in the series.
    // Can we get rid of it?
    yAxisObject: IUIChartPropertiesClientYAxis | undefined;
}

export class UIChartPropertiesClientSeries implements IUIChartPropertiesClientSeries {
    color: string | undefined = undefined;
    gallery:ChartTypesEnum | undefined = undefined;
    id: string | undefined = undefined;
    index?: number | undefined = undefined;
    seriesIndex: number | undefined = undefined;
    lineStyle?:ChartDashStylesEnum = undefined;
    lineWidth?: number = 1;
    markerShape?:ChartSymbolsEnum = undefined;
    name: string | undefined = undefined;

    // #region Version 1.2
    configDisplayName: string | undefined = undefined;
    objectID: number | undefined = undefined;
    objectType:eLynxObjectTypeEnum | undefined = undefined;
    displayTatID: number | undefined = undefined;
    displayTatTypeID: number | undefined = undefined;
    groupingFunction:NumericalFunctionEnum | undefined = undefined;
    groupingTimeframe:TimeframeType | undefined = undefined;
    order: number | undefined = undefined;
    sectionID: string | undefined = undefined;
    tatTypeID?: number | undefined = undefined;
    trendTypeID: number | undefined;
    // #endregion

    tag: string | undefined = undefined;
    tatID: number | undefined = undefined;
    uniqueID: string | undefined = undefined; // ???

    /// <summary>
    /// When using dual or multiple y axes, this number defines which yAxis the particular
    /// series is connected to. It refers to the index of the axis in the yAxis array, with 
    /// 0 being the first. Defaults to 0
    /// </summary>
    yAxis: number | undefined = undefined;
    // We should not need this on the client in the series.
    // Can we get rid of it?
    yAxisObject: IUIChartPropertiesClientYAxis | undefined = undefined;

    constructor(object?: IUIChartPropertiesClientSeries) {
        //User Story 53044: Research - 2025 Q2 - Review GAS report
        if (object !== undefined && object !== null) {
            this.color = object.color !== undefined ? object.color : undefined;
            this.gallery = object.gallery !== undefined ? object.gallery : undefined;
            this.id = object.id !== undefined ? object.id : undefined;
            this.index = object.index !== undefined ? object.index : undefined;
            this.seriesIndex = object.seriesIndex !== undefined ? object.seriesIndex : undefined;
            this.lineStyle = object.lineStyle !== undefined ? object.lineStyle : undefined;
            this.lineWidth = object.lineWidth !== undefined ? object.lineWidth : undefined;
            this.markerShape = object.markerShape !== undefined ? object.markerShape : undefined;
            this.name = object.name !== undefined ? object.name : undefined;
            this.configDisplayName = object.configDisplayName !== undefined ? object.configDisplayName : undefined;
            this.objectID = object.objectID !== undefined ? object.objectID : undefined;
            this.objectType = object.objectType !== undefined ? object.objectType : undefined;
            this.displayTatID = object.displayTatID !== undefined ? object.displayTatID : undefined;
            this.displayTatTypeID = object.displayTatTypeID !== undefined ? object.displayTatTypeID : undefined;
            this.groupingFunction = object.groupingFunction !== undefined ? object.groupingFunction : undefined;
            this.groupingTimeframe = object.groupingTimeframe !== undefined ? object.groupingTimeframe : undefined;
            this.order = object.order !== undefined ? object.order : undefined;
            this.sectionID = object.sectionID !== undefined ? object.sectionID : undefined;
            this.tatTypeID = object.tatTypeID !== undefined ? object.tatTypeID : undefined;
            this.trendTypeID = object.trendTypeID !== undefined ? object.trendTypeID : undefined;
            this.tatID = object.tatID !== undefined ? object.tatID : undefined;
            this.tag = object.tag !== undefined ? object.tag : undefined;
            this.uniqueID = object.uniqueID !== undefined ? object.uniqueID : undefined;
            this.yAxis = object.yAxis !== undefined ? object.yAxis : undefined;
            this.yAxisObject = object.yAxisObject !== undefined ? new UIChartPropertiesClientYAxis(object.yAxisObject) : undefined;
        }
    }

    // IEquatable Implementation
    public get equatableKey(): string {

        return UIChartPropertiesClientSeries.makeSeriesPropertyEquatableKey(this);
    }

    public set equatableKey(value: string) {

        const components: string[] = value.split(":");

        this.configDisplayName = components.length > 1 && components[1].length > 0 ? components[1] : undefined;
        this.objectID = components.length > 2 && components[2].length > 0 ? Number(components[2]) : undefined;
        this.objectType = components.length > 3 && components[3].length > 0 ? Number(components[3]) : undefined;
        this.displayTatID = components.length > 4 && components[4].length > 0 ? Number(components[4]) : undefined;
        this.displayTatTypeID = components.length > 5 && components[5].length > 0 ? Number(components[5]) : undefined;
        this.tatID = components.length > 6 && components[6].length > 0 ? Number(components[6]) : undefined;
        this.tatTypeID = components.length > 7 && components[7].length > 0 ? Number(components[7]) : undefined;
        this.groupingTimeframe = components.length > 8 && components[8].length > 0 ? Number(components[8]) : undefined;
        this.groupingFunction = components.length > 9 && components[9].length > 0 ? Number(components[9]) : undefined;
        this.sectionID = components.length > 10 && components[10].length > 0 ? components[10] : undefined;
        this.uniqueID = components.length > 11 && components[11].length > 0 ? components[11] : undefined;
    }

    public static makeSeriesPropertyEquatableKey(seriesProperty: IUIChartPropertiesClientSeries): string {

        return seriesProperty.groupingTimeframe === TimeframeType.LastKnownValue
            ? [
                typeof seriesProperty.configDisplayName == "string" ? seriesProperty.configDisplayName : "",
                typeof seriesProperty.objectID == "number" ? seriesProperty.objectID : "",
                typeof seriesProperty.objectType == "number" ? seriesProperty.objectType : "",
                typeof seriesProperty.displayTatID == "number" ? seriesProperty.displayTatID : "",
                typeof seriesProperty.displayTatTypeID == "number" ? seriesProperty.displayTatTypeID : "",
                typeof seriesProperty.tatID == "number" ? seriesProperty.tatID : "",
                typeof seriesProperty.tatTypeID == "number" ? seriesProperty.tatTypeID : "",
                typeof seriesProperty.groupingTimeframe == "number" ? seriesProperty.groupingTimeframe : "",
                "", //typeof groupingFunction == "number" ? groupingFunction : "",
                typeof seriesProperty.sectionID == "string" ? seriesProperty.sectionID : "",
                typeof seriesProperty.uniqueID == "string" ? seriesProperty.uniqueID : "",
            ].join(":")
            : [
                typeof seriesProperty.configDisplayName == "string" ? seriesProperty.configDisplayName : "",
                typeof seriesProperty.objectID == "number" ? seriesProperty.objectID : "",
                typeof seriesProperty.objectType == "number" ? seriesProperty.objectType : "",
                typeof seriesProperty.displayTatID == "number" ? seriesProperty.displayTatID : "",
                typeof seriesProperty.displayTatTypeID == "number" ? seriesProperty.displayTatTypeID : "",
                typeof seriesProperty.tatID == "number" ? seriesProperty.tatID : "",
                typeof seriesProperty.tatTypeID == "number" ? seriesProperty.tatTypeID : "",
                typeof seriesProperty.groupingTimeframe == "number" ? seriesProperty.groupingTimeframe : "",
                typeof seriesProperty.groupingFunction == "number" ? seriesProperty.groupingFunction : "0",
                typeof seriesProperty.sectionID == "string" ? seriesProperty.sectionID : "",
                typeof seriesProperty.uniqueID == "string" ? seriesProperty.uniqueID : "",
            ].join(":");
    }
}

export interface IUIChartPropertiesClientAxis extends IEquatable<string> {
    allowDecimals: boolean;
    //color?: string;
    //forceZero: boolean;
    gridsInterlaced: boolean;
    gridsInterlacedColor?: string;
    gridsMajorVisible: boolean
    gridLineColor?: string;
    gridLineDashStyle?:ChartDashStylesEnum;
    id: string | undefined;
    logarithmic: boolean;
    max?: number;
    min?: number;
    //minorGridLineColor: string;
    //minorGridLineDashStyle?:ChartDashStylesEnum;
    tag: string | undefined;
    titleText: string | undefined;
    index: number | undefined;

    // #region Version 1.2
    configDisplayName: string | undefined;
    order: number | undefined;
    uniqueID: string | undefined;
    
    // #endregion
}

export class UIChartPropertiesClientAxis implements IUIChartPropertiesClientAxis {
    allowDecimals: boolean = true;
    //color?: string | undefined = undefined;
    //forceZero: boolean = undefined;
    gridsInterlaced: boolean = false;
    //gridsInterlacedColor: string = 'lightgoldenrodyellow';
    gridsInterlacedColor: string | undefined = undefined;
    gridsMajorVisible: boolean = false;
    gridLineColor: string | undefined = undefined;
    gridLineDashStyle:ChartDashStylesEnum | undefined = undefined;
    id: string | undefined = undefined;
    logarithmic: boolean = false;
    max: number | undefined = undefined;
    min: number | undefined = undefined;
    //minorGridLineColor: string | undefined = undefined;
    //minorGridLineDashStyle?:ChartDashStylesEnum = undefined;
    tag: string | undefined = undefined;
    titleText: string | undefined = undefined;
    index: number | undefined = undefined;

    // #region Version 1.2
    configDisplayName: string | undefined = undefined;
    order: number | undefined = undefined;
    uniqueID: string | undefined = undefined;
    // #endregion

    constructor(object?: IUIChartPropertiesClientAxis) {
        //User Story 53044: Research - 2025 Q2 - Review GAS report
        if (object !== undefined && object !== null) {
            this.allowDecimals = object.allowDecimals !== undefined ? object.allowDecimals : true;
            this.configDisplayName = object.configDisplayName !== undefined ? object.configDisplayName : undefined;
            this.gridsInterlaced = object.gridsInterlaced !== undefined ? object.gridsInterlaced : false;
            this.gridsInterlacedColor = object.gridsInterlacedColor !== undefined ? object.gridsInterlacedColor : undefined;
            this.gridsMajorVisible = object.gridsMajorVisible !== undefined ? object.gridsMajorVisible : false;
            this.gridLineColor = object.gridLineColor !== undefined ? object.gridLineColor : undefined;
            this.gridLineDashStyle = object.gridLineDashStyle !== undefined ? object.gridLineDashStyle : undefined;
            this.id = object.id !== undefined ? object.id : undefined;
            this.logarithmic = object.logarithmic !== undefined ? object.logarithmic : false;
            this.max = object.max !== undefined ? object.max : undefined;
            this.min = object.min !== undefined ? object.min : undefined;
            this.order = object.order !== undefined ? object.order : undefined;
            this.tag = object.tag !== undefined ? object.tag : undefined;
            this.uniqueID = object.uniqueID !== undefined ? object.uniqueID : undefined;
            this.titleText = object.titleText !== undefined ? object.titleText : undefined;
            this.index = object.index !== undefined ? object.index : undefined;
        }
        else {
            this.gridsInterlaced = false;
            this.gridsInterlacedColor = undefined;
        }
    }

    // IEquatable Implementation
    public get equatableKey(): string {

        return UIChartPropertiesClientAxis.makeSeriesPropertyEquatableKey(this);
    }

    public set equatableKey(value: string) {
        const components: string[] = value.split(":");

        this.configDisplayName = components.length > 1 && components[1].length > 0 ? components[1] : undefined;
        this.id = components.length > 2 && components[2].length > 0 ? components[2] : undefined;
        this.tag = components.length > 3 && components[3].length > 0 ? components[3] : undefined;
        this.uniqueID = components.length > 4 && components[4].length > 0 ? components[4] : undefined;
    }

    public static makeSeriesPropertyEquatableKey(axisProperty: IUIChartPropertiesClientAxis): string {

        return [
            typeof axisProperty.configDisplayName == "string" ? axisProperty.configDisplayName : "",
            typeof axisProperty.id == "string" ? axisProperty.id : "",
            typeof axisProperty.tag == "string" ? axisProperty.tag : "",
            typeof axisProperty.uniqueID == "string" ? axisProperty.uniqueID : ""
        ].join(":");
    }
}

// This may go away
export interface IUIChartPropertiesClientXAxis extends IUIChartPropertiesClientAxis {
}

export class UIChartPropertiesClientXAxis extends UIChartPropertiesClientAxis implements IUIChartPropertiesClientXAxis {
    constructor(object?: IUIChartPropertiesClientXAxis) {
        super(object);
    }
}


// This may go away
export interface IUIChartPropertiesClientYAxis extends IUIChartPropertiesClientAxis {
}

export class UIChartPropertiesClientYAxis extends UIChartPropertiesClientAxis implements IUIChartPropertiesClientYAxis {
    constructor(object?: IUIChartPropertiesClientYAxis) {
        super(object);
    }
}

export interface IUIChartPropertiesClient {

    clone(): UIChartPropertiesClient | undefined;
    chart: IUIChartPropertiesClientChart | undefined;
    series: IUIChartPropertiesClientSeries[] | undefined;
    xAxis: IUIChartPropertiesClientXAxis[] | undefined;
    yAxis: IUIChartPropertiesClientYAxis[] | undefined;

    setOrder(): void;
    setSeriesOrder(): void;
    setYAxisOrder(): void;
}

export class UIChartPropertiesClient implements IUIChartPropertiesClient {
    chart: IUIChartPropertiesClientChart | undefined = undefined;
    series: IUIChartPropertiesClientSeries[] | undefined = undefined;
    xAxis: IUIChartPropertiesClientXAxis[] | undefined = undefined;
    yAxis: IUIChartPropertiesClientYAxis[] | undefined = undefined;

    constructor(object?: IUIChartPropertiesClient) {
        //User Story 53044: Research - 2025 Q2 - Review GAS report
        if (object !== undefined && object !== null) {
            this.chart = object.chart !== undefined ? new UIChartPropertiesClientChart(object.chart) : undefined;
            this.series = object.series !== undefined ? Enumerable.from(object.series)
                .select((series: IUIChartPropertiesClientSeries): UIChartPropertiesClientSeries => new UIChartPropertiesClientSeries(series)).toArray() : undefined;
            this.xAxis = object.xAxis !== undefined ? Enumerable.from(object.xAxis)
                .select((axis: IUIChartPropertiesClientXAxis): UIChartPropertiesClientXAxis => new UIChartPropertiesClientXAxis(axis)).toArray() : undefined;
            this.yAxis = object.yAxis !== undefined ? Enumerable.from(object.yAxis)
                .select((axis: IUIChartPropertiesClientYAxis): UIChartPropertiesClientYAxis => new UIChartPropertiesClientYAxis(axis)).toArray() : undefined;
        }
        else {
            this.chart = new UIChartPropertiesClientChart();
        }
    }

    public clone(): UIChartPropertiesClient {
        const model = new UIChartPropertiesClient(this);
        return model;
    }

    public setOrder(): void {
        this.setSeriesOrder();
        this.setYAxisOrder();
    }

    public setSeriesOrder(): void {
        if (this.series) {
            Enumerable.from(this.series)
                .orderBy(s => s.order)
                .select((series, index) => {
                    series.order = index;
                    return series;
                })
                .toArray();
        }
    }

    public setYAxisOrder(): void {
        if (this.yAxis) {
            Enumerable.from(this.yAxis)
                .orderBy(a => a.order)
                .select((yAxis, index) => {
                    yAxis.order = index;
                    return yAxis;
                })
                .toArray();
        }
    }
}

// #endregion Trending Configuration Chart Properties

export function cloneEmptyHighchartsSeries(series: IGraphSeriesOptions):
    IGraphSeriesOptions {

    return {
        animation: series.animation,
        name: series.name,
        tooltip: series.tooltip,
        type: series.type,
        yAxis: 0, //series.yAxis,
        color: series.color,
        step: series.step,
        dashStyle: series.dashStyle,
        marker: series.marker
    }
}
